export default __webpack_public_path__ + "static/media/Recruit's Agility.bc4cc300.jpg";